import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import { IApiLink } from "@/types"
import { ITaxBasedDeductionDto, TaxBasedDeduction } from "./TaxBasedDeduction"

export interface ITaxBasedDeductionsDto {
    entities?: ITaxBasedDeductionDto[]
    links?: IApiLink[]
}

export default class TaxBasedDeductions {
    items: TaxBasedDeduction[]
    linkCreate?: IApiLink

    constructor(dto: ITaxBasedDeductionsDto) {
        this.items = dto.entities?.map(e => new TaxBasedDeduction(e)) || []
        this.linkCreate = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.taxBasedDeduction && lnk.rel === ApiLinkRel.new)
    }
}
